import {
  SET_CAMPER_FORM_FIELD,
  SET_CAMPER_FORM
} from 'actions/account/campers/actionTypes'

const form = (state = {}, action) => {
  switch (action.type) {
    case SET_CAMPER_FORM_FIELD:
      return Object.assign({}, state, { [action.field]: action.value })
    case SET_CAMPER_FORM:
      return action.data
    default:
      return state
  }
}

export default form
